// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { ArrowBackIos } from '@material-ui/icons';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles,
} from '@material-ui/core';
import uuidv4 from 'uuid/v4';

import { statuses } from '../../../../../../../../config/types';
import MainRightInfo from '../MainRightInfo/MainRightInfo';
import MainLeftInfo from '../MainLeftInfo/MainLeftInfo';
import RejectionCell from '../RejectionCell/RejectionCell';
import statusRejected from '../../../../../../../../images/status-rejected.png';
import statusAccepted from '../../../../../../../../images/status-ok.png';
import statusInProgress from '../../../../../../../../images/status-in-progress.png';
import history from '../../../../../../../../services/history';
import styles from './styles.js';

const statusApplied = [7, 13, 15];
class OrderFullDesktop extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    order: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    order: {},
  };

  renderTop = () => {
    const { classes, order } = this.props;
    let statusId = 0;
    Object.keys(statuses).map((key) => {
      if (statuses[key] === order.OrderStatus) {
        statusId = key;
      }
      return null;
    });
    statusId = parseInt(statusId, 10);
    const background = statusApplied.includes(statusId) ? classes.paid : classes.processing;
    return (
      <div className={classNames(classes.topContainer, background)}>
        <div
          role={'button'}
          tabIndex={0}
          onKeyPress={() => history.goBack()}
          onClick={() => history.goBack()}
          className={classes.arrowBackContainer}
        >
          <ArrowBackIos />
          <div className={classes.link}>Back</div>
        </div>
        <span className={classes.orderIdText}>{`ORDER ID: ${order.OrderID}`}</span>
        <div className={classes.dateTimeContainer}>
          <span className={classes.orderTime}>{order.CreatedOn}</span>
        </div>
      </div>
    );
  }

  renderTable = () => {
    const { classes, order } = this.props;
    const rows = ['Title of The Item', 'Barcode', 'Sellitback Price',
      'Scanned On', 'Status', 'Rejection Info'];
    const itemProps = {
      padding: 'none',
      className: classes.rowItem,
      align: 'center',
    };
    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {rows.map(el => (
              <TableCell key={uuidv4()} className={classes.tableCell} align={'center'}>
                {el}
              </TableCell>))}
          </TableRow>
        </TableHead>
        <TableBody>
          {order.OrderDetails.map(row => (
            <TableRow key={uuidv4()}>
              <TableCell {...itemProps} component="th" scope="row">{row.Title}</TableCell>
              <TableCell {...itemProps}>{row.EAN}</TableCell>
              <TableCell {...itemProps}>{row.SellbackPrice.toFixed(2)}</TableCell>
              <TableCell {...itemProps}>{row.ScannedOn ? 'scanned' : 'not scanned'}</TableCell>
              <TableCell {...itemProps}>
                <img
                  className={classes.statusImage}
                  src={row.Accepted === 1
                    ? statusAccepted
                    : (row.Accepted === -1
                      ? statusRejected
                      : statusInProgress)}
                  alt={'status'}
                />
              </TableCell>
              <TableCell {...itemProps}>
                {row.Accepted === -1
                  ? <RejectionCell
                    RejectionReason={row.RejectionReason}
                    ImageURL={row.ImageURL}
                    OrderDetailsID={row.OrderDetailsID}
                  />
                  : null}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  render() {
    const { classes, order } = this.props;

    return (
      <div className={classes.mainContainer}>
        {this.renderTop()}
        <div className={classes.contentContainer}>
          <div className={classes.contentTopContainer}>
            <MainRightInfo order={order} />
            <MainLeftInfo order={order} />
          </div>
          {this.renderTable()}
        </div>
      </div>);
  }
}

export default withStyles(styles)(OrderFullDesktop);
